import { Component, EventEmitter } from "@angular/core";
import { URLSearchParams } from "@angular/http";
import { Platform, Keyboard, PopoverController } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Events } from "ionic-angular";

import { AlertController } from "ionic-angular";

import { AppConfig } from "../app/app.config";
import { Auth } from "../providers/auth/auth";
import { Api } from "../providers/api/api";
import {
  ApplicationError,
  AuthenticationFailedError,
} from "../providers/errors";
import { AngularFireProvider } from "../providers/firebase/angularfire";
import { MaintenanceProvider } from "../providers/maintenance/maintenance";
import { WebToAppPopoverProvider } from "../providers/popover/web-to-app-popover/web-to-app-popover";
import { Tracker } from "../providers/tracker/tracker";
import { MasterDataProvider } from "../providers/master-data/master-data";
import {
  LocalstorageProvider,
  KEYS,
} from "../providers/localstorage/localstorage";
import { ClientLogProvider } from "../providers/client-log/client-log";
import { DeeplinksProvider } from "../providers/deeplinks/deeplinks";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage: any;
  isMaintenance: boolean = false;
  isPasswordReset: boolean;

  resumeEmitter: EventEmitter<Event>;
  // FIXME: resumeが無限ループするので、その対処。原因は不明
  isShowingErrorAlert: boolean = false;
  isInitialized: boolean = false;
  url: string;

  constructor(
    public tracker: Tracker,
    public auth: Auth,
    public api: Api,
    public afp: AngularFireProvider,
    public maintenanceProvider: MaintenanceProvider,
    public webToAppPopoverProvider: WebToAppPopoverProvider,
    private clientLogProvider: ClientLogProvider,
    private deeplinksProvider: DeeplinksProvider,
    public masterDataProvider: MasterDataProvider,
    public localStorageProvider: LocalstorageProvider,
    public alertCtrl: AlertController,
    public events: Events,
    public platform: Platform,
    public popoverCtrl: PopoverController,
    keyboard: Keyboard,
    statusBar: StatusBar,
    splashScreen: SplashScreen
  ) {
    this.displaySubcscriptionModal();
    this.setWebTokenToLocalStorage();
    this.setFirstPage();
    this.setTransactionID();
    this.url = window.document.URL;
    history.replaceState("", "", "./");
    this.isPasswordReset = false;
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      keyboard.hideFormAccessoryBar(false);
      this.tracker.init();
      setTimeout(() => {
        splashScreen.hide();
      }, 1000);

      this.setIsPassReset();

      this.initialize();
    });
  }

  initialize(): void {
    this.isMaintenance = false;
    if (!this.resumeEmitter) {
      this.resumeEmitter = this.platform.resume.subscribe(() => {
        this.maintenanceProvider.check().subscribe(() => {
          if (this.isMaintenance) {
            this.initialize();
          } else {
            this.events.publish("platform:resume");
          }
        }, this.mantenanceHandler.bind(this));
      });
    }

    this.maintenanceProvider.check().subscribe(() => {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.api.initializeHeader();
        console.log("**** ready");
        console.log(AppConfig);
        this.afp.setPrefix(AppConfig.FIREBASE_PREFIX);
        this.authenticate();
      }
    }, this.mantenanceHandler.bind(this));
  }

  mantenanceHandler(error): void {
    if (error.status && error.status === 599) {
      this.isMaintenance = true;
      this.rootPage = "MaintenancePage";
    } else {
      const that = this;
      const alert = this.alertCtrl.create({
        title: "エラー",
        subTitle: "エラーが発生しました。時間をおいて再度お試しください。",
        buttons: [
          {
            text: "リトライする",
            handler: that.initialize.bind(that),
          },
        ],
      });
      alert.present();
    }
  }

  successAuthenticate(): void {
    this.rootPage = "TabsPage";
  }
  failAuthenticate(): void {
    this.rootPage = "OnboardingPage";
  }

  setIsPassReset(): void {
    const hash = localStorage.getItem("deepLinks");
    if (!hash) {
      return;
    }
    this.deeplinksProvider.match(hash).then((res) => {
      if (res && res.page && res.page === "PasswordConfirmationPage") {
        this.isPasswordReset = true;
      } else {
        this.isPasswordReset = false;
      }
    });
  }

  async authenticate() {
    // master-dataがsyncされるまで待つ
    await this.masterDataProvider.asyncData();
    this.auth
      .authenticate()
      .then((res) => {
        if (res) {
          if (!this.isPasswordReset) {
            this.successAuthenticate();
          } else {
            this.failAuthenticate();
          }
        } else {
          this.failAuthenticate();
        }
      })
      .catch((error) => {
        if (error instanceof AuthenticationFailedError) {
          const alert = this.alertCtrl.create({
            title: error.name,
            subTitle: error.message,
            buttons: [
              {
                text: "OK",
                handler: () => {
                  this.auth.removeToken().then(() => {
                    this.failAuthenticate();
                  });
                },
              },
            ],
          });
          alert.present();
        } else if (error instanceof ApplicationError) {
          const alert = this.alertCtrl.create({
            title: error.name,
            subTitle: error.message,
            buttons: [
              {
                text: "OK",
                handler: () => {
                  this.authenticate();
                },
              },
            ],
          });
          alert.present();
        } else {
          throw error;
        }
      });
  }

  displaySubcscriptionModal(): void {
    var splitURL: string[];
    var rawParams: string;
    var params: URLSearchParams;
    var registered;
    if (!!localStorage.getItem("deepLinks")) {
      splitURL = localStorage.getItem("deepLinks").split("/");
      rawParams = splitURL[splitURL.length - 1].replace("search?", "");
      params = new URLSearchParams(rawParams);
      registered = params.get("registered");
    }

    if (
      registered === "success" &&
      this.localStorageProvider.getValue(KEYS.DialogFlag) != "true"
    ) {
      this.tracker.trackEventForGA("registered");
      this.tracker.pushEventForFBViaGTM("registered");

      let meID: number = Number(this.localStorageProvider.getValue(KEYS.MeID));
      if (meID) {
        this.tracker.pushEventForFBViaGTM("purchase-xxx");
      }
      this.tracker.pushEventForPresco(meID, 1);
      this.tracker.pushEventTj();
      const alert = this.alertCtrl.create({
        title: "ご購入ありがとうございます",
        subTitle: "正常に購入処理が完了しました。",
        buttons: [
          {
            text: "OK",
            handler: () => {
              this.events.publish("axes_premium_subscription:success");
            },
          },
        ],
      });
      alert.present();
      this.localStorageProvider.setValue(KEYS.DialogFlag, "true");
    } else if (registered === "failure") {
      this.tracker.trackEventForGA("registered_failure");
      const alert = this.alertCtrl.create({
        title: "エラー",
        subTitle: "購入に失敗しました。",
        buttons: [
          {
            text: "OK",
          },
        ],
      });
      alert.present();
      this.localStorageProvider.setValue(KEYS.DialogFlag, "true");
    }
  }

  private setWebTokenToLocalStorage(): void {
    const splitURL: string[] = document.URL.split("/");
    let rawParams: string = splitURL[splitURL.length - 1];
    rawParams = rawParams.slice(rawParams.indexOf("?t=") + 1);
    const params: URLSearchParams = new URLSearchParams(rawParams);
    const token: string = params.get("t");
    if (token) {
      if (localStorage.getItem(KEYS.WebTrackToken) !== token) {
        this.sendWebTrackTokenClick(token);
      }
      localStorage.setItem(KEYS.WebTrackToken, token);
    }
  }

  private setFirstPage(): void {
    const urlParams = document.URL.split("?").slice(-1)[0];
    const params = new URLSearchParams(urlParams);
    const moveToPage = params.get("move_to");
    if (moveToPage) {
      if (localStorage.getItem(KEYS.MoveTo) !== moveToPage) {
        localStorage.setItem(KEYS.MoveTo, moveToPage);
      }
    }
  }

  private sendWebTrackTokenClick(token: string): void {
    this.clientLogProvider.webTrackTokenClick(token);
  }

  private setTransactionID(): void {
    const splitURL: string[] = document.URL.split("/");
    let rawParams: string = splitURL[splitURL.length - 1];
    rawParams = rawParams.slice(rawParams.indexOf("?subid=") + 1);
    const params: URLSearchParams = new URLSearchParams(rawParams);
    const token: string = params.get("subid");
    if (token) {
      localStorage.setItem(KEYS.TransactionIDTj, token);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts